import angular from 'angular';
import HttpDimService from './httpDim.service';

let httpDimModule = angular.module('httpDim', []).service('httpDim', HttpDimService);

export default httpDimModule;



// WEBPACK FOOTER //
// ./app/common/httpDim/httpDim.js